import {
  type InformationSectionType,
  QUESTION_TYPE_OPTIONS,
  PValueField,
} from '@exam-management/qcontent-management';
import {
  Flex,
  FormControl,
  FormHelperText,
  FormLabel,
  FormRadio,
  FormRadioSelection,
  RadioGroup,
} from '@shared/components';
import { useFormContext } from 'react-hook-form';

export default function InformationFormSection() {
  const formContext = useFormContext<InformationSectionType>();

  const pValueErrorMessages = formContext.formState.errors?.information?.pValue?.selected
    ?.message as string;

  return (
    <Flex
      sx={(theme) => ({
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        rowGap: theme.spacing(3),
        columnGap: theme.spacing(6),
      })}
    >
      <FormRadioSelection
        name='information.calculated'
        label='ประเภทข้อสอบ'
        options={QUESTION_TYPE_OPTIONS}
        required
        row
        sx={{
          minWidth: 196,
        }}
      />
      <FormControl>
        <FormLabel required>ค่าความยาก (P)</FormLabel>
        <RadioGroup
          row
          sx={(theme) => ({ gap: theme.spacing(4), mt: theme.spacing(1), flexWrap: 'wrap' })}
        >
          <Flex
            sx={{
              alignItems: 'flex-start',
            }}
          >
            <FormRadio
              name='information.pValue.selected'
              value='pInitial'
              label='P Initial'
              sx={{
                width: '100%',
                maxWidth: 96,
              }}
            />
            <PValueField
              placeholder='ระบุค่า P'
              controllerProps={{
                name: 'information.pValue.pInitial',
                control: formContext.control,
              }}
              sx={{
                maxWidth: 128,
              }}
            />
          </Flex>
        </RadioGroup>
        <FormHelperText error>{pValueErrorMessages}</FormHelperText>
      </FormControl>
    </Flex>
  );
}
